import { Link } from "react-router-dom";
import { LOGO_BLACK, TAGLINE } from "@/lib/branding";

export const Footer = () => {
  return (
    <footer className="w-full border-t border-[rgba(35,82,119,0.10)] mt-16">
      <div className="max-w-[1040px] mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-col items-center sm:items-start gap-1.5">
          <img
            src={LOGO_BLACK}
            alt="Gino Body & Soul"
            className="h-7 w-auto opacity-80"
            data-testid="footer-logo-image"
          />
          <p className="text-xs text-[#9E9E9E]" data-testid="footer-tagline">
            {TAGLINE}
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Link
            to="/confidentialite"
            data-testid="footer-privacy-link"
            className="text-xs text-[#235277] underline underline-offset-2"
          >
            Politique de confidentialité
          </Link>
          <Link
            to="/mentions"
            data-testid="footer-legal-link"
            className="text-xs text-[#235277] underline underline-offset-2"
          >
            Mentions légales
          </Link>
          <Link
            to="/statut"
            data-testid="footer-status-link"
            className="text-xs text-[#235277] underline underline-offset-2"
          >
            Statut du service
          </Link>
        </div>
      </div>
    </footer>
  );
};
